import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSelectedBp } from 'features/bpDetails/ducks/selectors'
import { selectAccessRequests } from 'features/AccessRequest/ducks/selectors'
import { getAccessRequestsRoutine } from 'features/AccessRequest/ducks/actions'
import { getUnitAccessRequestsRoutine } from 'ducks/units/actions'
import { selectUnitRequestsList } from 'ducks/units/selectors'
import { isNotNilOrEmpty } from 'utils/ramda'
import { filterOutStaff } from 'utils/user'
import RequestSection from './RequestBox'

const RequestsList = ({ unit, canAccept, items, onAccept, onDeny, onCountChange = () => {} }) => {
  const bp = useSelector(getSelectedBp)
  const bpRequests = useSelector(selectAccessRequests)
  const unitRequests = useSelector(selectUnitRequestsList)
  const dispatch = useDispatch()

  const selectorRequests = useMemo(
    () => (isNotNilOrEmpty(unit) ? (unitRequests || []) : (bpRequests || [])),
    [unit, unitRequests, bpRequests]
  )

  const requests = useMemo(
    () => filterOutStaff(items != null ? items : selectorRequests) || [],
    [items, selectorRequests]
  )

  useEffect(() => {
    if (items != null) return
    if (!canAccept) return
    if (unit && bp) {
      dispatch(getUnitAccessRequestsRoutine({ bpId: bp.id, unitId: unit.id }))
    } else if (bp) {
      dispatch(getAccessRequestsRoutine({ bpId: bp.id }))
    }
  }, [dispatch, bp, unit, canAccept, items])

  useEffect(() => {
    onCountChange(Array.isArray(requests) ? requests.length : 0)
  }, [requests, onCountChange])

  return (
    <RequestSection
      requests={requests || []}
      unit={unit}
      bp={bp}
      canAccept={canAccept}
      onAccept={onAccept}
      onDeny={onDeny}
      onCountChange={onCountChange}
    />
  )
}

export default RequestsList
